import { SettingsTextField } from '@/components/settings/SettingsTextField.tsx';
import { SettingTitle } from '@/components/settings/SettingsTitle.tsx';
import { DashboardContext } from '@/contexts/DashboardContext.tsx';
import { Links } from '@superfunnel/types';
import Button from '@superfunnel/ui-core/v2/Button';
import { Separator } from '@superfunnel/ui-core/v2/Separator';
import { useContext, useEffect, useState } from 'react';
export const LinksTab = () => {
  const [edit, setEdit] = useState<boolean>(false);
  const { accountConfig, updateAccountConfig } = useContext(DashboardContext);
  const [links, setLinks] = useState<Links>({});
  const [websiteLink, setWebsiteLink] = useState<string>('');
  const [termsOfUseLink, setTermsOfUseLink] = useState<string>('');
  const [privacyPolicyLink, setPrivacyPolicyLink] = useState<string>('');

  useEffect(() => {
    if (!accountConfig?.websiteLink) return;

    setWebsiteLink(accountConfig.websiteLink);
  }, [accountConfig?.websiteLink]);

  useEffect(() => {
    if (!accountConfig?.termsOfUseLink) return;

    setTermsOfUseLink(accountConfig.termsOfUseLink);
  }, [accountConfig?.termsOfUseLink]);

  useEffect(() => {
    if (!accountConfig?.privacyPolicyLink) return;

    setPrivacyPolicyLink(accountConfig.privacyPolicyLink);
  }, [accountConfig?.privacyPolicyLink]);

  useEffect(() => {
    if (!accountConfig?.links) return;

    setLinks(accountConfig.links);
  }, [accountConfig?.links]);

  useEffect(() => {
    if (!accountConfig?.links) return;

    setLinks(accountConfig.links);
  }, [accountConfig?.links]);

  useEffect(() => {
    if (!accountConfig) return;
    const website =
      accountConfig?.websiteLink === undefined
        ? ''
        : accountConfig?.websiteLink;
    const termsOfUse =
      accountConfig?.termsOfUseLink === undefined
        ? ''
        : accountConfig?.termsOfUseLink;
    const privacyPolicy =
      accountConfig?.privacyPolicyLink === undefined
        ? ''
        : accountConfig?.privacyPolicyLink;

    setEdit(
      website !== websiteLink ||
        termsOfUse !== termsOfUseLink ||
        privacyPolicy !== privacyPolicyLink ||
        JSON.stringify(accountConfig?.links) !== JSON.stringify(links),
    );
  }, [accountConfig, links, websiteLink, termsOfUseLink, privacyPolicyLink]);

  const onDiscard = () => {
    setEdit(false);
    setWebsiteLink(accountConfig?.websiteLink || '');
    setTermsOfUseLink(accountConfig?.termsOfUseLink || '');
    setPrivacyPolicyLink(accountConfig?.privacyPolicyLink || '');
    setLinks(accountConfig?.links || {});
  };

  const onSave = () => {
    setEdit(false);
    updateAccountConfig({
      websiteLink,
      termsOfUseLink,
      privacyPolicyLink,
      links,
    });
  };

  return (
    <>
      <div
        className={
          'relative grid h-full w-full max-w-full grid-rows-[1fr_auto] overflow-hidden'
        }
      >
        <div className={'h-full overflow-y-auto'}>
          <div className={'mx-auto flex w-full max-w-161 flex-col gap-5 px-2.5 pb-5'}>
            <SettingTitle
              title="General links"
              description="Links that will be used in all of your landing pages"
            />
            <SettingsTextField
              title="Logo link"
              prefix={'https://'}
              value={websiteLink}
              setValue={setWebsiteLink}
            />
            <SettingsTextField
              title="Terms of use"
              prefix={'https://'}
              value={termsOfUseLink}
              setValue={setTermsOfUseLink}
            />
            <SettingsTextField
              title="Privacy policy"
              prefix={'https://'}
              value={privacyPolicyLink}
              setValue={setPrivacyPolicyLink}
            />

            <Separator />

            <SettingTitle
              title="Social links"
              description="Links that will be used in all of your landing pages"
            />

            <SettingsTextField
              title="Instagram"
              prefix={'instagram.com'}
              value={links['instagram'] || ''}
              setValue={(v: string) => setLinks({ ...links, instagram: v })}
            />
            <SettingsTextField
              title="Facebook"
              prefix={'facebook.com'}
              value={links['facebook'] || ''}
              setValue={(v: string) => setLinks({ ...links, facebook: v })}
            />
            <SettingsTextField
              title="GitHub"
              prefix={'github.com'}
              value={links['github'] || ''}
              setValue={(v: string) => setLinks({ ...links, github: v })}
            />
            <SettingsTextField
              title="TikTok"
              prefix={'tiktok.com'}
              value={links['tiktok'] || ''}
              setValue={(v: string) => setLinks({ ...links, tiktok: v })}
            />
            <SettingsTextField
              title="YouTube"
              prefix={'youtube.com'}
              value={links['youtube'] || ''}
              setValue={(v: string) => setLinks({ ...links, youtube: v })}
            />
            <SettingsTextField
              title="X (Twitter)"
              prefix={'x.com'}
              value={links['x'] || ''}
              setValue={(v: string) => setLinks({ ...links, x: v })}
            />
            <SettingsTextField
              title="LinkedIn"
              prefix={'linkedin.com'}
              value={links['linkedin'] || ''}
              setValue={(v: string) => setLinks({ ...links, linkedin: v })}
            />
          </div>
        </div>
      </div>
      {edit && (
        <div className={'w-full'}>
          <span className={'block w-full h-px bg-[linear-gradient(90deg,rgba(228,231,236,0)_0%,#E4E7EC_50.35%,rgba(228,231,236,0)_100%)]'}/>
          <div
          className={
            'mx-auto flex w-full max-w-161 justify-end gap-3 bg-white px-2.5 pt-2'
          }
        >
          <Button variant={'outline'} onClick={onDiscard}>
            Discard
          </Button>
          <Button onClick={onSave}>Save</Button>
        </div>
        </div>
      )}
    </>

  );
};
